import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FormRadio } from './form';
import { Button } from './buttons';
import { Edit } from './icons';
import profileIcons from './icons/profileIcons';

import './ProfileOption.scss'; 

const ProfileOption = ({
  icon = 'tulip',
  id = '',
  isEditing = false,
  onEdit = () => {},
  onSelect = () => {},
  title = ''
}) => {
  const { t } = useTranslation();

  const handleEdit = () => {
    onEdit(id);
  };

  const handleSelect = (e) => {
    if (e && e.currentTarget && e.currentTarget.value) {
      const profileId = e.currentTarget.value.replace(/^profile_/, '');
      onSelect(profileId);
    } else {
      onSelect(id);
    }
  };

  return (
    <div
      className={classNames('profile-option', {
        'profile-option--editing': isEditing
      })}
    >
      <FormRadio
        name="profile"
        value={`profile_${id}`}
        imageSrc={profileIcons[icon]}
        onClick={handleSelect}
        onChange={handleSelect}
      >
        {title}
      </FormRadio>
      
      {isEditing && (
        <Button
          className="profile-option__edit-button"
          colorScheme="blue"
          type="button"
          onClick={handleEdit}
          ariaLabel={t('profile.editButton', 'Edit Profile')}
        >
          <Edit
            className="profile-option__edit-button-icon"
            viewBox="0 0 32 32"
            width="1.6rem"
            height="1.6rem"
          />
        </Button>
      )}
    </div>
  );
};

ProfileOption.propTypes = {
  icon: PropTypes.string,
  id: PropTypes.string,
  isEditing: PropTypes.bool,
  onEdit: PropTypes.func,
  onSelect: PropTypes.func,
  title: PropTypes.string
};

export default ProfileOption;
